
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetomatheranbustravels() {



    const cardData =
    {
        keyword: 'Pune to Matheran Bus Travel',
        heading: 'Amruta Travels: Pune to Matheran Bus Travel',
        headingDescription: 'Amruta Travels offers Pune to Matheran Bus Travel, providing a reliable and comfortable transportation solution for your journey to the serene hill station of Matheran. Whether you are planning a family outing, corporate retreat, or group tour, our well-maintained buses ensure a smooth and enjoyable ride through the picturesque Western Ghats. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your Matheran trip simple and stress-free. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. Book your Pune to Matheran Bus with Amruta Travels and embark on a journey of comfort and discovery!',


        top: 'Top Places to Visit in Matheran with Amruta Travels',
"topPlaces": [
  {
    "title": "Louisa Point",
    "description": "Louisa Point is one of Matheran's most picturesque viewpoints, offering panoramic vistas of the surrounding valleys, the historic Prabal Fort, and the shimmering waters of Charlotte Lake. Especially captivating during sunrise and sunset, the point provides a tranquil setting for nature lovers and photographers alike."
  },
  {
    "title": "Charlotte Lake",
    "description": "Nestled amidst dense forests, Charlotte Lake serves as the primary source of drinking water for Matheran. Flanked by the ancient Pisarnath Mahadev Temple on one end and Echo Point on the other, the lake is a serene spot ideal for picnics and leisurely walks, especially during the monsoon when it's brimming with water."
  },
  {
    "title": "Panorama Point",
    "description": "True to its name, Panorama Point offers a 360-degree view of the surrounding landscape, including the distant towns of Neral and Bhivpuri. It's a favored spot for witnessing both sunrise and sunset, and on clear days, one can even glimpse the winding tracks of the Matheran toy train below."
  },
  {
    "title": "One Tree Hill Point",
    "description": "This unique viewpoint is named after a solitary tree that stands atop the hill. The trail leading to One Tree Hill is a favorite among trekkers, offering a moderate hike through lush greenery and culminating in breathtaking views of the valleys below."
  },
  {
    "title": "Echo Point",
    "description": "A popular spot among tourists, Echo Point is known for the natural echo phenomenon it offers. Shout out loud, and hear your voice reverberate through the hills. The point also provides splendid views of the Sahyadri ranges and is especially lively during the monsoon season."
  },
  {
    "title": "Porcupine Point (Sunset Point)",
    "description": "Renowned for its mesmerizing sunset views, Porcupine Point offers a tranquil setting to watch the sun dip below the horizon. The point is surrounded by dense forests and provides a panoramic view of the Prabalgad Fort and the vast expanse of the Western Ghats."
  },
  {
    "title": "Neral-Matheran Toy Train",
    "description": "An engineering marvel from the British era, the narrow-gauge toy train offers a scenic journey from Neral to Matheran, winding through dense forests, over quaint bridges, and around sharp curves. The leisurely ride provides travelers with picturesque views and a nostalgic experience."
  },
  {
    "title": "Dodhani Waterfalls",
    "description": "Located on the outskirts of Matheran, Dodhani Waterfalls is a hidden gem, especially during the monsoon. Adventure enthusiasts can indulge in waterfall rappelling here, while others can enjoy the serene ambiance and the soothing sound of cascading water."
  },
  {
    "title": "Vikatgad (Peb Fort)",
    "description": "A favorite among trekkers, Vikatgad, also known as Peb Fort, offers a challenging trek through dense forests and rocky terrains. At the summit, explorers are rewarded with panoramic views and can explore ancient caves, cisterns, and a temple dedicated to Lord Shiva."
  },
  {
    "title": "Pisharnath Mahadev Mandir",
    "description": "This ancient temple, dedicated to Lord Shiva, is believed to be the oldest in Matheran. Located near Charlotte Lake, the temple is surrounded by dense forests, offering a peaceful ambiance for devotees and visitors seeking tranquility."
  }
],



"services": [
    {
      "name": "Pune to Matheran Bus Rental Service",
      "description": "Amruta Travels offers reliable and comfortable bus rental services from Pune to Matheran. Ideal for groups, families, and corporate teams, our buses come with AC, push-back seating, and experienced drivers, making your journey to this eco-friendly hill station pleasant and safe."
    },
    {
      "name": "Hire a Bus from Pune to Matheran",
      "description": "Planning a trip to Matheran? Hire a well-maintained bus from Pune with Amruta Travels for a scenic and convenient ride. We offer multiple seating capacities, including 25, 32, and 50-seater buses suitable for all types of travel groups, ensuring a smooth experience through the ghats."
    },
    {
      "name": "Pune to Matheran Bus Service",
      "description": "Our Pune to Matheran bus service is designed for tourists and travelers looking for hassle-free transportation. With on-time pickups, comfortable buses, and expert drivers familiar with the terrain, we ensure a worry-free travel experience to one of Maharashtra’s top hill stations."
    },
    {
      "name": "Pune to Matheran Tour Bus Rental",
      "description": "Enjoy a full-fledged tour of Matheran with our tour bus rental service from Pune. Perfect for sightseeing and guided group travel, our buses are equipped with audio-visual features, cushioned seating, and large windows to take in the beautiful views en route."
    },
    {
      "name": "Pune to Matheran Bus Package Tour",
      "description": "Book a comprehensive Pune to Matheran bus package tour with Amruta Travels. Our packages include transportation, sightseeing stops, and customized itineraries for families, schools, or corporate outings. Choose from various bus sizes and enjoy a relaxing journey."
    },
    {
      "name": "Pune to Matheran Family Trip Bus Hire",
      "description": "Looking for a family getaway to Matheran? Hire a comfortable bus from Amruta Travels with family-friendly amenities and AC options. Our drivers are courteous and experienced, ensuring a safe and joyful travel experience for your loved ones."
    },
    {
      "name": "Pune to Matheran Weekend Getaway Bus Rental for Trip",
      "description": "Escape the city with our weekend bus rental service to Matheran. Ideal for quick getaways and short breaks, our fleet includes various seating options, clean interiors, and entertainment systems to make your weekend ride as relaxing as the destination."
    },
    {
      "name": "Pune to Matheran Group Travel Bus Hire",
      "description": "For group travel to Matheran, Amruta Travels offers spacious buses with ample legroom and luggage space. Whether it's a college trip, office outing, or friends' reunion, we ensure a safe and enjoyable ride tailored to your group size."
    },
    {
      "name": "Pune to Matheran Sightseeing Bus Rental",
      "description": "Explore Matheran’s scenic viewpoints with our sightseeing bus rental from Pune. Our experienced drivers and comfortable buses will guide you through a planned itinerary covering all major attractions, including Echo Point, Louisa Point, and Panorama Point."
    },
    {
      "name": "AC Bus Hire Pune to Matheran",
      "description": "Travel to Matheran in comfort with our fully air-conditioned buses. Equipped with reclining seats, onboard storage, and smooth suspension, our AC buses offer a luxurious ride perfect for summer trips or long drives through the Western Ghats."
    },
    {
      "name": "Comfortable Bus from Pune to Matheran - Book Now",
      "description": "Book your ride today with Amruta Travels for a comfortable and enjoyable journey from Pune to Matheran. Choose from 25, 32, or 50-seater buses based on your group size, and enjoy professional service, clean buses, and timely transportation."
    },
    {
      "name": "25-Seater Bus Hire from Pune to Matheran",
      "description": "Hire a 25-seater bus for your next Matheran trip from Pune. Ideal for mid-sized groups, our buses come with AC, ample luggage space, and experienced drivers to ensure a safe and scenic ride through the ghats and into the lush hills."
    },
    {
      "name": "32 Seater Bus Rental Pune to Matheran",
      "description": "Amruta Travels offers 32-seater bus rentals from Pune to Matheran for educational tours, weddings, and group outings. Our buses are well-maintained, equipped with AC, push-back seats, and safety features for a worry-free journey."
    },
    {
      "name": "50 Seater Bus Hire From Pune to Matheran",
      "description": "Need to transport a large group? Choose our 50-seater buses for travel from Pune to Matheran. These high-capacity buses are perfect for school trips, corporate tours, or large family gatherings, offering reliability and on-road comfort."
    },
    {
      "name": "Pune to Matheran One Day Tour Package",
      "description": "Experience the best of Matheran in a single day with our all-inclusive one-day tour package from Pune. Includes transportation, sightseeing stops, and flexible scheduling for a quick yet fulfilling escape to the hills."
    }
  ],
  "tableData": [
    ["Pune to Matheran Bus Rental Service", "Hire a Bus from Pune to Matheran"],
    ["Pune to Matheran Bus Service", "Pune to Matheran Tour Bus Rental"],
    ["Pune to Matheran Bus Package Tour", "Pune to Matheran Family Trip Bus Hire"],
    ["Pune to Matheran Weekend Getaway Bus Rental for Trip", "Pune to Matheran Group Travel Bus Hire"],
    ["Pune to Matheran Sightseeing Bus Rental", "AC Bus Hire Pune to Matheran"],
    ["Comfortable Bus from Pune to Matheran - Book Now", "25-Seater Bus Hire from Pune to Matheran"],
    ["32 Seater Bus Rental Pune to Matheran", "50 Seater Bus Hire From Pune to Matheran"],
    ["Pune to Matheran One Day Tour Package", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Pune to Matheran Bus Travel with Amruta Travels",
    "WhyChoosedescription": "Amruta Travels offers convenient and comfortable bus services from Pune to Matheran, perfect for group outings, nature lovers, and weekend getaways. Our buses provide a stress-free and scenic ride right up to the base of this eco-sensitive hill station. With options suitable for families, students, corporate teams, and tour groups, we make your journey as relaxing as the destination itself."
  },
  {
    "WhyChooseheading": "Ideal for One-Day Trips, Weekend Getaways, and Nature Retreats",
    "WhyChoosedescription": "Our Pune to Matheran bus services are tailored for one-day tours or extended weekend retreats. Whether you’re planning a quick escape from the city or organizing a nature retreat with your team, we ensure timely departure, multiple pickup points across Pune, and a smooth ride to Matheran’s entry point—Dasturi Naka—where you can continue by toy train, horseback, or on foot."
  },
  {
    "WhyChooseheading": "Multiple Bus Sizes for Group Travel",
    "WhyChoosedescription": "We offer a fleet that includes 17, 20, 32, 35, 40, 45, and 50-seater buses to suit all group sizes. Our vehicles are well-maintained, clean, and equipped with comfortable seating, air-conditioning (or Non-AC as per your preference), and plenty of luggage space—perfect for carrying picnic baskets, trekking gear, or overnight bags."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Scenic Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with the route to Matheran, including the hilly terrain near Neral. With safety as our top priority, they ensure a smooth ride and timely arrival. We also factor in scenic break points or rest stops so you can enjoy the journey as much as the destination."
  },
  {
    "WhyChooseheading": "Affordable Group Travel with Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive pricing for Pune to Matheran bus travel with no hidden charges. Whether it’s a day trip or a weekend tour, our transparent rental structure includes driver fees, fuel, tolls, and taxes—making it easy for you to plan your travel expenses in advance."
  },
  {
    "WhyChooseheading": "Hygienic, Clean, and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are sanitized before every trip and regularly serviced to ensure maximum cleanliness and passenger safety. From cushioned seats to clean windows and interiors, we prioritize hygiene and comfort—especially for families and children heading for a nature-filled experience."
  },
  {
    "WhyChooseheading": "Customizable Itineraries and Flexible Timings",
    "WhyChoosedescription": "We understand that every group has unique needs, which is why our Pune to Matheran travel packages offer full itinerary flexibility. Whether you want early morning departures, late evening returns, stopovers at Lonavala or Karjat, or overnight stays near Neral—we customize everything to fit your schedule."
  },
  {
    "WhyChooseheading": "Simple Booking Process and 24/7 Customer Assistance",
    "WhyChoosedescription": "Booking a bus from Pune to Matheran is easy with Amruta Travels. Use our website, call our customer care, or visit our office to reserve your preferred bus. Our support team is available 24/7 to assist with route planning, last-minute changes, or emergency support during the trip."
  }
]















    }

const faqData = [
  {
    question: 'How can I book a bus from Pune to Matheran?',
    answer: 'You can book a Pune to Matheran bus trip with Amruta Travels through our website, by phone, or by visiting our office. We’ll help you select the right bus based on your group size and travel preferences.',
  },
  {
    question: 'What types of buses are available for Pune to Matheran travel?',
    answer: 'We offer a range of buses including 32, 35, 40, 45, and 50-seater AC and non-AC options. Luxury and semi-sleeper coaches are also available for a more comfortable journey.',
  },
  {
    question: 'Is the route from Pune to Matheran safe for bus travel?',
    answer: 'Yes, the route is safe and scenic. Our experienced drivers are familiar with the terrain and ensure a safe and pleasant journey. Since Matheran is a vehicle-free hill station, the bus will drop you at Dasturi Naka, the entrance point.',
  },
  {
    question: 'How long does the bus trip from Pune to Matheran take?',
    answer: 'The travel time from Pune to Matheran is approximately 3.5 to 4.5 hours depending on traffic and weather conditions. We plan our trips to ensure timely arrival and ample rest stops.',
  },
  {
    question: 'Can I rent a bus for a group tour to Matheran?',
    answer: 'Yes, we specialize in group bookings for school trips, corporate outings, family tours, and weekend getaways to Matheran. Customized packages are available based on your group’s needs.',
  },
  {
    question: 'Do you provide a return trip from Matheran to Pune?',
    answer: 'Yes, we offer round-trip services. You can book a return journey at the time of initial booking or request it separately based on your itinerary.',
  },
  {
    question: 'What amenities are included in the bus?',
    answer: 'Our buses come equipped with comfortable push-back seats, air conditioning (if opted), music system, charging points (in select buses), and ample space for luggage.',
  },
  {
    question: 'Are there extra charges for tolls and parking?',
    answer: 'Yes, tolls and parking charges are generally extra unless you’ve opted for an all-inclusive package. We provide clear pricing at the time of booking.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Matheran bus hire?',
    answer: 'Amruta Travels offers well-maintained buses, professional drivers, and reliable service with flexible pickup points and customized plans. We ensure a smooth and enjoyable trip to Matheran.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Pravin Deshmukh',
    role: 'Corporate Team Leader, Pune',
    text: 'We hired a 40-seater bus for a weekend trip to Matheran. The bus was clean, arrived on time, and the journey was very smooth. Amruta Travels provided excellent service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anuja Kale',
    role: 'School Trip Coordinator',
    text: 'We organized a school picnic to Matheran with Amruta Travels. The bus was spacious and safe, and the driver was extremely cooperative. Highly recommended for group trips!',
    rating: 5,
  },
];





























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Matheran Bus Travel",
  "image": "https://bushireinpune.com/assets/images/pune-to-matheran-bus.jpg",
  "description": "Amruta Travels offers bus rental services for trips from Pune to Matheran. Choose from 25, 32, or 50-seater buses for comfortable and affordable travel. We offer Matheran bus packages, one-day tours, group travel, family trips, and weekend getaway buses. Book now for a scenic and enjoyable journey from Pune to Matheran.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2760"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999", // Adjust price as needed
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-matheran-bus-travel"
  }
};



    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Matheran Bus Travel | Weekend Getaways & Sightseeing | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book buses from Pune to Matheran for group travel, family trips, or weekend getaways. Choose from 25, 32, 50-seater buses. Comfortable and affordable sightseeing trips, one-day tours, and more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomatheranbustravels;